import {
  FlaggedType,
  Member,
  ModerationItem,
} from '@tribeplatform/gql-client/types'
import { dayjs } from '@tribeplatform/react-components/common/lib'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { useNetworkRoles } from '@tribeplatform/react-sdk/hooks'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { Link } from '@tribeplatform/react-ui-kit/Link'

export const ModerationItemNote = ({
  moderationItem,
  flaggedBy = FlaggedType.SYSTEM,
}: {
  moderationItem: ModerationItem
  flaggedBy?: FlaggedType
}) => {
  const { $t } = useI18n()
  const { Link: RouterLink } = useRouter()
  const { guest: guestRole } = useNetworkRoles()
  if (flaggedBy === FlaggedType.SYSTEM) {
    const texts = moderationItem?.description?.split('\n') ?? []
    const descriptions = texts.map((text, id) => ({
      text,
      id,
    }))

    return (
      <>
        {descriptions.map(({ text, id }) => (
          <Alert key={id} status="neutral" title={text} />
        ))}
      </>
    )
  }

  const totalReportsCount = moderationItem?.reporters?.totalCount ?? 0

  if (!totalReportsCount) {
    return null
  }
  const memberName = (moderationItem.entity as Member)?.name
  return (
    <Alert
      status="neutral"
      title={$t(
        {
          defaultMessage:
            '{is_member, select, true {{reported_member_name}} other {This item}} is reported {total_reports_count, plural, one {# time} other {# times}}',
          id: 'Admin.Moderation.MemberTotalReportsCount',
        },
        {
          total_reports_count: totalReportsCount,
          reported_member_name: memberName,
          is_member: !!memberName,
        },
      )}
    >
      <ul className="flex flex-col space-y-3">
        {moderationItem?.reporters?.nodes?.map(report => (
          <li key={report.id}>
            <T
              defaultMessage={`Reported by {reporter} as {report_category} {relative_report_time}{has_description, select, false {} other {: "{description}"}}`}
              id="Admin.Moderation.ReporterDetail"
              values={{
                reporter: (
                  <Link
                    className="font-medium"
                    href={report.reporter?.relativeUrl}
                    variant="neutral"
                    as={RouterLink}
                    disabled={report.reporter?.roleId === guestRole?.id}
                  >
                    {report.reporter?.name}
                  </Link>
                ),
                report_category: (
                  <strong className="font-medium">
                    {report.reportCategory?.toLowerCase()}
                  </strong>
                ),
                relative_report_time: dayjs(report.createdAt).fromNow(),
                has_description: !!report.description,
                description: report.description,
              }}
            />
          </li>
        ))}
      </ul>
    </Alert>
  )
}
